<template>
  <router-view/>
</template>

<style lang="less">
body{
  margin:0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.el-header{
  padding:0;
}
.header{
  overflow: hidden;
}
.header .breadcrumb{
  float: left;
  line-height: 32px;
}
.editbtn{
  float: right;
}
.pagestyle{
  margin: 20px 0;
  text-align: right;
  float: right;
  width: 100%;
}

.avatar-uploader .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  text-align: center;
}
.marleft{
  margin-left: 10px;
}
.martop{
  margin-top: 10px;
}
.marright{
  margin-right: 10px;
}
.marbottom{
  margin-bottom: 10px;
}
.greptips{
  color: #999999;
  width: 100%;
}
</style>
